import PropTypes from 'prop-types';
import { useProducts } from '@activebrands/core-web/contexts/ProductsContext';
import FacetGroups from 'components/product-listing/FacetGroups';
import useSortConfigQuery from 'queries/useSortConfigQuery';

const CategoryFacetGroups = ({ priceFacetRange, onHandleFilter }) => {
    const { enabledFacets: cmsEnabledFacets } = useSortConfigQuery();
    const {
        addFacetFilter,
        applyFacetFilters,
        clearFacetFilters,
        facets,
        removeFacetFilter,
        selectedFacets,
        products,
    } = useProducts();

    const selectedPrice = selectedFacets.find(f => f.facet === 'price')?.value || priceFacetRange;

    return (
        <FacetGroups
            addFacetFilter={addFacetFilter}
            applyFacetFilters={applyFacetFilters}
            clearFacetFilters={clearFacetFilters}
            enabledFacets={cmsEnabledFacets}
            facets={facets}
            hits={products.length}
            overlayId="category-facet-groups"
            priceFacetRange={priceFacetRange}
            removeFacetFilter={removeFacetFilter}
            selectedFacets={selectedFacets}
            selectedPrice={selectedPrice}
            onHandleFilter={onHandleFilter}
        />
    );
};

CategoryFacetGroups.propTypes = {
    onHandleFilter: PropTypes.func,
    priceFacetRange: PropTypes.shape({
        max: PropTypes.number,
        min: PropTypes.number,
    }).isRequired,
};

export default CategoryFacetGroups;
